(() => {
  'use strict';
  if (window.elyProfessionalServices) { window.elyProfessionalServices.init(document); return; }
  const controllers = new Map();
  const unlock = () => document.documentElement.classList.toggle('mfg-dialog-open', Boolean(document.querySelector('dialog[data-mfg-dialog][open]')));
  function init(scope) {
    const roots = [...scope.querySelectorAll('[data-mfg-professional]')];
    if (scope.matches?.('[data-mfg-professional]')) roots.unshift(scope);
    roots.forEach(root => {
      if (controllers.has(root)) return;
      const controller = new AbortController(), { signal } = controller;
      controllers.set(root, controller);
      let returnFocus = null;
      root.addEventListener('click', event => {
        const opener = event.target.closest('[data-ps-open]');
        const closer = event.target.closest('[data-ps-close]');
        if (opener) {
          const dialog = root.querySelector(`#${CSS.escape(opener.getAttribute('aria-controls'))}`);
          if (!dialog) return;
          returnFocus = opener;
          dialog.querySelectorAll('details[open]').forEach(detail => { detail.open = false; });
          dialog.showModal();
          dialog.querySelector('.mfg-ps-dialog-body').scrollTop = 0;
          unlock();
        } else if (closer) closer.closest('dialog').close();
      }, { signal });
      root.querySelectorAll('dialog').forEach(dialog => {
        let backdropStart = false;
        dialog.addEventListener('pointerdown', event => { backdropStart = event.target === dialog; }, { signal });
        dialog.addEventListener('click', event => {
          const box = dialog.getBoundingClientRect();
          if (backdropStart && event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) dialog.close();
          backdropStart = false;
        }, { signal });
        dialog.addEventListener('close', () => { unlock(); if (returnFocus?.isConnected) returnFocus.focus({ preventScroll: true }); }, { signal });
      });
    });
  }
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, controller] of controllers) {
      if (event.target === root || event.target.contains(root)) {
        root.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
        controller.abort(); controllers.delete(root);
      }
    }
    unlock();
  });
  window.elyProfessionalServices = { init };
  init(document);
})();
